import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

let serviceWorkerUrl = null;
if(import.meta.env.MODE === 'development') {
  serviceWorkerUrl = '/mockServiceWorker.js';
} else {
  serviceWorkerUrl = '/service-worker.js';
}

// index.tsx (only in dev)
async function enableMocking() {
  if (import.meta.env.MODE !== 'development') {
    return
  }
  console.log("Node Environment:", import.meta.env.MODE);

  try {
    console.log("Importing worker from ./mocks/browser...");
    const { worker } = await import('./mocks/browser')
    console.log("Worker imported, starting worker...");
    
    // Configure worker with better options
    await worker.start({
      onUnhandledRequest: 'bypass',
      quiet: false
    });
    
    console.log("Worker started successfully");
    return;
  } catch (error) {
    console.error("MSW Worker start failed:", error);
    return;
  }
}

if ('serviceWorker' in navigator) {
  console.log("Registering production service worker...");
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(serviceWorkerUrl)
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

enableMocking().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );})